export interface TrackingStage {
  key: string;
  label: string;
  icon: string;
  description: string;
}

export interface StatusEvent {
  status: string;
  date: string;
  note: string;
}

export interface TrackingOrder {
  id: number;
  order_id: number | null;
  cpf_cnpj: string;
  customer_name: string | null;
  customer_email: string | null;
  product_description: string | null;
  status: string;
  status_history: StatusEvent[];
  coupon_code: string | null;
  reviewed: boolean;
  referral_pix_key: string | null;
  referral_code: string | null;
  created_at: string;
  updated_at: string;
}

export const TRACKING_STAGES: TrackingStage[] = [
  {
    key: 'pedido_recebido',
    label: 'Pedido recebido',
    icon: 'ri-shopping-bag-3-line',
    description: 'Recebemos seu pedido. Em até 48h enviamos para a fábrica.',
  },
  {
    key: 'enviado_fabrica',
    label: 'Enviado para a fábrica',
    icon: 'ri-building-2-line',
    description: 'Seu pedido foi enviado para a produção.',
  },
  {
    key: 'finalizado_fabrica',
    label: 'Finalizado na fábrica',
    icon: 'ri-tools-line',
    description: 'A produção terminou e seu pedido está pronto.',
  },
  {
    key: 'em_transporte',
    label: 'Em transporte',
    icon: 'ri-truck-line',
    description: 'Seu pedido saiu da fábrica e está a caminho de Caruaru.',
  },
  {
    key: 'pronto_entrega',
    label: 'Pronto para entrega',
    icon: 'ri-map-pin-line',
    description: 'Seu pedido chegou em Caruaru e está pronto para entrega.',
  },
  {
    key: 'entregue_cliente',
    label: 'Entregue ao cliente',
    icon: 'ri-check-double-line',
    description: 'Tudo entregue! Aproveite seus móveis.',
  },
];